import { PinInputField, PinInput as PinInputChakra } from "@chakra-ui/react";
import styled from "styled-components";
import { Text } from "../typography/Texts";

import { T } from "../i18n/Translation";
import { FadeInAnimation } from "../fadeIn/FadeInAnimation";
import { useTheme } from "src/apps/providers/ThemeStore";
import { colors } from "@permisso/permisso-components";

const DOCUMENTATION_AREA_LOGIN_PIN_INPUT_TITLE = "documentation_area.login.pin_input.title";

type PinInputProps = {
  length: number;
  value: string;
  onChange: (value: string) => void;
  error?: string;
};

export const PinInput = ({ length, value, onChange, error }: PinInputProps) => {
  const { fontFamily, primaryColor, primaryButtonBackgroundColor, errorColor, blackColor } =
    useTheme();
  return (
    <PinInputContainer>
      <Text>
        <T k={DOCUMENTATION_AREA_LOGIN_PIN_INPUT_TITLE} />
      </Text>
      <PinInputChakraContainer>
        <PinInputChakra
          otp
          value={value}
          onChange={onChange}
          placeholder="A"
          isInvalid={Boolean(error)}
          errorBorderColor={errorColor}
          focusBorderColor={primaryButtonBackgroundColor ?? primaryColor}
        >
          {[...Array(length)].map((_, i) => (
            <PinInputField
              key={`pinInput_${i}`}
              _placeholder={{ color: colors.grey400 }}
              width={"2.5rem"}
              height={"2.5rem"}
              fontSize={"2rem"}
              fontWeight={"400"}
              fontFamily={fontFamily}
              borderWidth={1}
              color={blackColor}
            />
          ))}
        </PinInputChakra>
      </PinInputChakraContainer>
      <ErrorTextContainer>
        {error ? (
          <FadeInAnimation duration={0.4}>
            <Text $color={errorColor}>{error}</Text>
          </FadeInAnimation>
        ) : null}
      </ErrorTextContainer>
    </PinInputContainer>
  );
};

const ErrorTextContainer = styled(Text)`
  align-self: start;
`;

const PinInputChakraContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.375rem;
`;

const PinInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
